import { CreateScreeningService } from '@/app/pages/screening-brief-create/services/create-screening/create-screening.service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BbField } from '@/app/pages/create-brief-select/ui/bb-field/bb-field';

@Component({
  selector: 'sbs-brief-basics',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BbField],
  templateUrl: './brief-basics.html',
  styleUrl: './brief-basics.scss',
})
export class BriefBasics {

  /** Services */
  public readonly createScreeningService = inject(CreateScreeningService);
  /** Services - END */

  setTitle(value: string): void {
    this.createScreeningService.basicInfoModel.set({ briefTitle: value });
  }
}
